import { ReactComponent } from "/builds/mb/front/src/app/assets/images/appliedOfferBand.svg?react";
import url from "/builds/mb/front/src/app/assets/images/appliedOfferBand.svg?url";
export { ReactComponent };
export default url;
